import {
  PROJECTS_BLUE_COLOR_NAME,
  MARKETING_RED_COLOR_NAME,
  CRM_GREEN_COLOR_NAME,
  DEV_ORANGE_COLOR_NAME
} from "styles/color-consts";

import {
  MARKETING,
  CRM,
  GENERIC_CLUSTER,
  OPERATIONS,
  DESIGN_AND_CREATIVE,
  SOFTWARE,
  HR,
  IT,
  PROJECT_MANAGEMENT_USE_CASE
} from "constants/clusters";

export const starsClusters = [
  {
    text: "Creative & design",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/design_icon.png",
    colorName: "sofia-pink",
    clusterId: DESIGN_AND_CREATIVE
  },
  {
    text: "IT",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/it_icon.png",
    colorName: "purple-v2",
    clusterId: IT
  },
  {
    text: "Software development",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/dev_icon.png",
    colorName: DEV_ORANGE_COLOR_NAME,
    clusterId: SOFTWARE
  },
  {
    text: "Marketing",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/marketing_icon.png",
    colorName: MARKETING_RED_COLOR_NAME,
    clusterId: MARKETING
  },
  {
    text: "Project management",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/pmo_icon.png",
    colorName: PROJECTS_BLUE_COLOR_NAME,
    clusterId: GENERIC_CLUSTER,
    useCaseId: PROJECT_MANAGEMENT_USE_CASE
  },
  {
    text: "Sales & CRM",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/crm_icon.png",
    colorName: CRM_GREEN_COLOR_NAME,
    clusterId: CRM
  },
  {
    text: "Task management",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/task_icon.png",
    colorName: "light-blue-v2",
    clusterId: GENERIC_CLUSTER
  },
  {
    text: "HR",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/hr_icon.png",
    colorName: "sunset",
    clusterId: HR
  },
  {
    text: "Operations",
    image:
      "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/first_fold/icons/operations_icon.png",
    colorName: "aquamarine",
    clusterId: OPERATIONS
  }
];

export const stars = [
  // top left
  { top: 160, left: -129 },
  { top: 227, left: -106 },
  { top: 20, left: -20 },
  { top: 128, left: 220 },
  { top: 73, left: 315 },
  { top: 218, left: 12 },

  // middle
  { top: 50, left: 510 },
  { top: 35, left: 855 },
  { top: 449, left: 424 },
  { top: 515, left: 387 },

  // near signup
  { top: 495, left: 826 },
  { top: 487, left: 865 },
  { top: 480, left: 856 },

  // right
  { top: 24, left: 1036 },
  { top: 59, left: 1138 },
  { top: 86, left: 1087 },
  { top: 380, left: 1378 },
  { top: 202, left: 1522 }
];
